/* eslint-disable */

export const createDepthBotConstant = {
    FETCH_CREATE_DEPTH_BOT_REQUEST: 'FETCH_CREATE_DEPTH_BOT_REQUEST',
    FETCH_CREATE_DEPTH_BOT_SUCCESS: 'FETCH_CREATE_DEPTH_BOT_SUCCESS',
    FETCH_CREATE_DEPTH_BOT_FAILURE: 'FETCH_CREATE_DEPTH_BOT_FAILURE',
};
